import loadable from '@loadable/component'

const RedirectLinkPartnerModal = loadable(() => import('./internal'))

export default RedirectLinkPartnerModal
